import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BigIntBaseEntity } from './base.entity';

/**
 * PD-17609 — one Instantly mailbox's sending on one day, as Instantly's daily
 * report per mailbox gives it (`GET /accounts/analytics/daily`: follow-ups and
 * subsequences included). The nightly INSTANTLY_SYNC mailbox-analytics job
 * reads the last few weeks back every night and stores what changed, so a
 * day Instantly finished counting late is corrected the next night.
 *
 * The Instantly settings page judges each sender group's mailbox use from
 * these rows (balanced, idle mailboxes, at the limit most days), and later
 * campaign reports can read the same history.
 *
 * `dailyLimit` is the mailbox's limit when the day was first stored, so a
 * limit raised later does not rewrite how close to it the mailbox ran.
 *
 * BigInt key: one row per mailbox per day across hundreds of mailboxes. Not
 * auditable: a nightly job's machine data would drown `_audit`.
 */
@Index('IDX_instantly_mailbox_day_mailbox_day', ['mailboxEmail', 'day'], { unique: true })
@Index('IDX_instantly_mailbox_day_day', ['day'], {})
@Entity('instantly_mailbox_day', {}, { auditable: false })
export class InstantlyMailboxDayEntity extends BigIntBaseEntity {
	/** The sending mailbox, lower-cased (Instantly's `email_account`). */
	@Column('varchar', { name: 'mailboxEmail', length: 320 })
	public mailboxEmail!: string;

	/** The day as Instantly reports it (YYYY-MM-DD). */
	@Column('date', { name: 'day' })
	public day!: string;

	/** Emails sent, follow-ups and subsequences included. */
	@Column('int', { name: 'sent', default: () => '0' })
	public sent!: number;

	@Column('int', { name: 'bounced', default: () => '0' })
	public bounced!: number;

	/** People who got any email from this mailbox that day. */
	@Column('int', { name: 'contacted', default: () => '0' })
	public contacted!: number;

	/** People who got their first email that day. */
	@Column('int', { name: 'newPeopleContacted', default: () => '0' })
	public newPeopleContacted!: number;

	@Column('int', { name: 'replies', default: () => '0' })
	public replies!: number;

	/** Automatic replies (out of office and the like). */
	@Column('int', { name: 'automaticReplies', default: () => '0' })
	public automaticReplies!: number;

	/** The mailbox's daily limit when this day was first stored; null when Instantly gave none. */
	@Column('int', { name: 'dailyLimit', nullable: true })
	public dailyLimit!: number | null;
}
